import I18n from '@src/i18n';
import styled from '@src/styled-components';
import { Col, Form, Icon, Input, InputNumber, Row, Select } from 'antd';
import React from 'react';

const FormItem = Form.Item;
const Option = Select.Option;

export interface IScoreTaskProps {
  form: any;
  onChangeSelect: any;
  onChangeScore: any;
  onChangeLabel: any;
  handleRemoveScore: any
  valueSelect: string;
  valueScore: string;
  valueLabel: string;
  
}

interface IScoreTaskState {

}
export default class ScoreTask extends React.Component<IScoreTaskProps, IScoreTaskState> {
  constructor(props: IScoreTaskProps) {
    super(props);

    this.state = {

    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Wrapper>

        <Form>
          <Row>
            <Col sm={4} md={4} xl={4} style={{ marginTop: '7px' }}>
              <span>{I18n.l("formflow.components.score.sumCompare")}</span>
            </Col>
            <Col sm={4} md={4} xl={4}>
              <FormItem>
                {getFieldDecorator('select', {
                  initialValue: this.props.valueSelect,
                  rules: [{ required: true, message: I18n.l("common.fieldRequired") }],
                })(
                  <Select style={{ width: '90%' }} onChange={this.props.onChangeSelect} >
                    <Option value={'equals'}>igual a</Option>
                    <Option value={'great'}>maior que</Option>
                    <Option value={'less'}>menor que</Option>
                  </Select>
                )}
              </FormItem>
            </Col>
            <Col sm={4} md={4} xl={4}>
              <FormItem>
                {getFieldDecorator('number', {
                  initialValue: this.props.valueScore,
                  rules: [{ required: true, message: I18n.l("common.fieldRequired") }],
                })(
                  <InputNumber min={0} style={{ width: '100%' }} onChange={this.props.onChangeScore} />
                )}
              </FormItem>
            </Col>
            <Col sm={4} md={4} xl={4}>
              <Icon
                style={{ color: 'red', marginLeft: '30px', marginTop: '10px', cursor: "pointer" }}
                type="close"
                onClick={this.props.handleRemoveScore}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={4} md={4} xl={4} style={{ marginTop: '7px' }}>
              <span>{I18n.l("formflow.components.score.sumLabel")}</span>
            </Col>
            <Col sm={4} md={4} xl={4}>
              <FormItem>
                {getFieldDecorator('status', {
                  initialValue: this.props.valueLabel,
                  rules: [{ required: true, message: I18n.l("common.fieldRequired") }],
                })(
                  <Input placeholder={I18n.l("formflow.components.score.sumLabelPlaceholder")} style={{ width: '100%' }} onChange={this.props.onChangeLabel} />
                )}
              </FormItem>
            </Col>
          </Row>

        </Form>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
    width:100%;
    margin-top: 2rem;
    margin-left: 3rem;
    padding-right: 50px;

`


export const ScoreComponetValidated = Form.create()(ScoreTask);